module.exports = __webpack_public_path__ + "static/media/10.49fda230.jpg";